<template>
  <!--BEGIN-->
  <div>
    <div v-if="hasApprovalDetailView()">
      <span
        v-if="datasource.hasAllMinimized"
        @click="apply('NOT_MINIMIZED')"
        class="text-primary hand"
        v-b-tooltip.hover
        :title="$t('minimization.status.not-minimize-all-datasource')"
      >
        <i class="fa fa-check-circle"></i>
        {{ $t("minimization.status.minimized") }}
      </span>
      <span v-else @click="apply('MINIMIZED')" class="hand" v-b-tooltip.hover :title="$t('minimization.status.minimize-all-datasource')">
        <i class="fa fa-circle"></i>
        {{ $t("minimization.status.not-minimized") }}
      </span>
    </div>
    <div v-if="hasApprovePermission()">
      <span v-if="datasource.hasUnapprovedItem" @click="approve()" class="text-primary hand" v-b-tooltip.hover :title="$t('minimization.approve-all-datasource')">
        <i class="fa fa-check-circle"></i>
        {{ $t("minimization.approve") }}
      </span>
    </div>
    <span v-if="!datasource.hasUnapprovedItem" class="text-success">
      <i class="fa fa-info-circle"></i>
      {{ $t("minimization.collect.approved") }}
    </span>
  </div>

  <!--END-->
</template>

<script>
export default {
  props: ["department", "process", "datasource", "thirdParty"],

  methods: {
    async apply(status) {
      const response = await this.$store.dispatch("minimization/updateDatasourceTransferMinimization", {
        id: this.datasource._id,
        organizationThirdPartyId: this.thirdParty._id,
        status,
      });

      // this.datasource = response.data;
      this.$emit("onSave");
    },

    async approve() {
      const response = await this.$store.dispatch("minimization/approveDatasourceTransferMinimization", {
        id: this.datasource._id,
        organizationThirdPartyId: this.thirdParty._id,
      });
      // this.datasource = response.data;
      this.$emit("onSave");
    },

    hasApprovePermission() {
      if (this.currentAccountHasPermissions(["ORGANIZATION_GDPR_PRODUCT_ADMIN", "ORGANIZATION_KVKK_PRODUCT_ADMIN", "ORGANIZATION_LEGAL_ADMIN"])) {
        return true;
      }

      if (this.department.admins.find((a) => a._id == this.currentAccount._id) || this.process.admins.find((a) => a._id == this.currentAccount._id)) {
        return true;
      }

      return false;
    },
    hasApprovalDetailView() {
      if (
        this.currentAccountHasPermissions([
          "ORGANIZATION_GDPR_PRODUCT_ADMIN",
          "ORGANIZATION_KVKK_PRODUCT_ADMIN",
          "ORGANIZATION_INFORMATION_TECHNOLOGY_ADMIN",
          "ORGANIZATION_RISK_ADMIN",
          "ORGANIZATION_LEGAL_ADMIN",
        ])
      ) {
        return true;
      }

      if (this.department.admins.find((a) => a._id == this.currentAccount._id) || this.process.admins.find((a) => a._id == this.currentAccount._id)) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style></style>
